import React from 'react';

interface LiveMeetingsIconProps {
  className?: string;
  size?: number;
  color?: string;
}

// Live/upcoming meetings: the calendar mark of MeetingsIcon with a "live" dot
// in the corner to signal the filtered (not-yet-completed) variant.
const LiveMeetingsIcon: React.FC<LiveMeetingsIconProps> = ({ className, size = 24, color = 'currentColor' }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="1.6" />
    <path d="M3 9.5H21" stroke={color} strokeWidth="1.6" />
    <path d="M8 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M16 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M8 15L11 15" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M8 18L14 18" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="18" cy="6" r="3.4" fill="#e5484d" stroke="#fff" strokeWidth="1.4" />
  </svg>
);

export default LiveMeetingsIcon;
